module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQYAAABWCAIAAACirq8oAAAACXBIWXMAABJ0AAASdAHeZh94AAAAB3RJTUUH5AsLCAsHklNY9AAAAMNJREFUeNrt0zERADAIALFSDUjEGj6ZcMCYSPi7j6x+wPoSgCXAEmAJsARYAiwBlgBLgCXAEmAJsARYAiwBlgBLgCXAEmAJwBJgCbAEWAIsAZYAS4AlwBJgCbAEWAIsAZYAS4AlwBJgCbAEWAKwBFgCLAGWAEuAJcASYAmwBFgCLAGWAEuAJcASYAmwBFgCLAGWACwBlgBLgCXAEmAJsARYAiwBlgBLgCXAEmAJsARYAiwBlgBLgCUAS4AlwBJgCbAEXBlCHQHJ5xI8pQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/img/solidarity/euroSolidario.png
// module id = 2263
// module chunks = 0